import { Message } from '@alifd/next';
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

import client from '@/lib/feathers';
import { generateHouseHoldNumberCascader } from '@/utils/generateHouseHoldNumberCascader';

import { Option } from '../types';
import CreateFinanceRecord from './components/CreateFinanceRecord/index';
import CreateMonthlyBillButton from './components/CreateMonthlyBillButton';
import DownloadDialog from './components/DownloadDialog';
import styles from './index.module.scss';

const residentAccountNumbers = client.service('residentAccountNumbers');

export default function FinanceFunc({ setTrigger }) {
  const [residentsData, setResidentsData] = useState<any[]>([]);
  const [cascadeArr, setCascadeArr] = useState<Option[]>([]);

  // 取得住戶資料
  useEffect(() => {
    (async () => {
      try {
        const result = await residentAccountNumbers.find({ query: {} });
        setResidentsData(result.data);
      } catch (error) {
        console.error(error);
        Message.error('資料取得失敗');
      }
    })();
  }, []);

  // 在取得住戶資料後將資料轉換成Cascader可用的格式
  useEffect(() => {
    const objectData = generateHouseHoldNumberCascader(
      residentsData
        .filter((data) => data.effectiveStatus)
        .map((data) => data.householdNumber)
    );
    setCascadeArr(objectData);
  }, [residentsData]);

  return (
    <div className={styles.functionContainer}>
      {/* 按鈕功能 */}
      <div className={styles.functionButton}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '10px',
          }}
        >
          <CreateFinanceRecord {...{ cascadeArr, setTrigger }} />
          <CreateMonthlyBillButton {...{ setTrigger }} />
          <DownloadDialog />
        </Box>
      </div>
    </div>
  );
}
